<ejs-dialog
	#modal
	cssClass="modal-md"
    [closeOnEscape]="false"
    [showCloseIcon]="false"
	[attr.data-test-id]="'practicePayTerminalModal'">
	<ng-template #header>
		<div class="dlg-template">Terminal Payment</div>
	</ng-template>
	<ng-template #content>
		@if (errors.length) {
			<div class="alert alert-danger">
				<ul>
					@for (error of errors; track error) {
						<li><strong>{{ error }}</strong></li>
					}
				</ul>
			</div>
		}
		@if (isLoading || isProcessing) {
			<div class="text-center padding-md">
				<i class="fa fa-spinner fa-spin fa-2x"></i>
				@if (isLoading) {
					<p class="margin-top-sm">Connecting to terminal...</p>
				}
				@if (isProcessing) {
					<p class="margin-top-sm">Processing payment...</p>
				}
			</div>
		}
		@if (iframeUrl && !isLoading && !isProcessing) {
			<div class="practice-pay-iframe-container">
				<iframe
					[src]="iframeUrl"
					(load)="onIframeLoad()"
					class="practice-pay-iframe"
					[attr.data-test-id]="'practicePayTerminalIframe'">
				</iframe>
			</div>
		}
	</ng-template>
	<ng-template #footerTemplate>
	</ng-template>
</ejs-dialog>
